@let _card = card();
@if (_card.img) {
    <img [width]="_card.img.width" [height]="_card.img.height" [attr.alt]="_card.img.alt" [ngSrc]="src()" />
}
<div class="card-content justify-end">
    <div class="p-4 z-10 flex flex-col">
        @if (behavior() === "link") {
            <a [routerLink]="_card.link" class="title flex items-start justify-between w-full">
                <span class="line-clamp lines-3 hover:underline"> {{ _card.title }}</span>
                <span class="hover-icon material-symbols-outlined">arrow_outward</span>
            </a>
        } @else if (behavior() === "emit") {
            <a href="javascript:;" class="title flex items-start justify-between w-full">
                <span class="line-clamp lines-3 hover:underline"> {{ _card.title }}</span>
                <span class="hover-icon material-symbols-outlined">arrow_outward</span>
            </a>
        } @else {
            <h3 href="javascript:;" class="title flex items-start justify-between w-full">
                <span class="line-clamp lines-3"> {{ _card.title }}</span>
            </h3>
        }

        @if (_card.description) {
            <span class="font-normal text-base text-slate-700">
                {{ _card.description }}
            </span>
        }

        @if (_card.date) {
            <span class="font-normal text-sm text-slate-300">
                {{ _card.date | date: "dd MMM yyyy" }}
            </span>
        }
    </div>
</div>
